const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { PRIVATE_PAGE_ROBOTS } from "@/lib/seo-meta";
import { requireAdmin } from "./guards";
export const Route = createFileRoute("/_app/admin")({
  beforeLoad: ({
    context: {
      queryClient
    },
    location
  }) => requireAdmin({
    queryClient,
    location
  }),
  head: () => ({
    meta: [{
      name: "robots",
      content: PRIVATE_PAGE_ROBOTS
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});